// import { Navbar } from '../components/Navbar';
// import { Footer } from '../components/Footer';
import { PublicMatrimonyProfile } from "@/components/matrimony/M-PublicProfile";

const PublicMatrimonyProfilePage = () => {
  return (
    <div className="">
      {/* <Navbar /> */}
      <main className="a">
        <PublicMatrimonyProfile />
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default PublicMatrimonyProfilePage;
